import script from "./whiteListManage.vue?vue&type=script&setup=true&lang=js"
export * from "./whiteListManage.vue?vue&type=script&setup=true&lang=js"

import "./whiteListManage.vue?vue&type=style&index=0&id=3d6e1ed8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d6e1ed8"]])

export default __exports__